import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NewButtonComponent } from '../../shared/components/new-button/new-button.component';
import { TableComponent } from '../../shared/components/table/table.component';
import { AcceptanceCriteriaService } from '../../core/services/acceptance-criteria.service';
import { AcceptanceCriteria } from '../../core/models/acceptance-criteria.model';
import { RouterModule } from '@angular/router';
import { ConfirmPopupComponent } from '../../shared/components/confirm-popup/confirm-popup.component';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatButtonModule } from '@angular/material/button';
import { AcceptanceCriteriaDetailComponent } from '../acceptance-criteria-detail/acceptance-criteria-detail.component';

@Component({
  selector: 'app-acceptance-criteria-list',
  templateUrl: './acceptance-criteria-list.component.html',
  styleUrls: ['./acceptance-criteria-list.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    NewButtonComponent,
    TableComponent,
    ConfirmPopupComponent,
    MatPaginatorModule,
    MatSortModule,
    MatTableModule,
    MatButtonModule,
    AcceptanceCriteriaDetailComponent,
  ],
})
export class AcceptanceCriteriaListComponent implements OnInit {
  criteriaList: AcceptanceCriteria[] = [];
  criteriaToDelete: AcceptanceCriteria | null = null;
  selectedCriteria: AcceptanceCriteria | null = null; // Para el criterio seleccionado
  tableColumns = [
    { header: 'ID', field: 'id' },
    { header: 'Nombre', field: 'name' },
    { header: 'Descripción', field: 'description' },
    { header: 'Estado', field: 'disabled' },
  ];

  constructor(private criteriaService: AcceptanceCriteriaService) {}

  ngOnInit(): void {
    this.getAcceptanceCriteria();
  }

  getAcceptanceCriteria(): void {
    this.criteriaService
      .getAcceptanceCriteria()
      .subscribe(criteria => (this.criteriaList = criteria));
  }

  confirmDelete(criteria: AcceptanceCriteria): void {
    this.criteriaToDelete = criteria;
  }

  onDeleteConfirm(): void {
    if (this.criteriaToDelete && this.criteriaToDelete.id !== undefined) {
      this.criteriaService.deleteAcceptanceCriteria(this.criteriaToDelete.id).subscribe(() => {
        this.getAcceptanceCriteria();
        this.criteriaToDelete = null;
      });
    }
  }

  onDeleteCancel(): void {
    this.criteriaToDelete = null;
  }

  toggleCriteriaStatus(criteria: AcceptanceCriteria): void {
    criteria.disabled = !criteria.disabled;
    this.criteriaService.disabledAcceptanceCriteria(criteria).subscribe(() => {
      this.getAcceptanceCriteria();
    });
  }

  selectCriteria(criteria: AcceptanceCriteria): void {
    this.selectedCriteria = criteria; // Asigna el criterio seleccionado
  }

  closeCriteriaDetail(): void {
    this.selectedCriteria = null; // Cierra el detalle del criterio
  }
}
